import { MdAdd, MdDelete, MdStar } from "react-icons/md";
import ImageUpload from "../ImageUpload";

const CSat = ({language, handleChange, prefix, question, touched, errors, getQuestionType, statements, optionData, pairData, showSuggestions, handleStatementChange, handleAddStatement, handleRemoveStatement, handleAddColumn, handleRemoveColumn, handlePairChange, handleAddRow, handleRemoveRow, questionData, values, handleInputChange, handleInputFocus, handleInputBlur, filteredSuggestions, handleSuggestionClick, options, answer, sharedAnswerHandler, solution, setFieldValue }) => {
    return (
        <div className="py-2 mt-3">

            <div className="mt-4">
                <p className="text-2xl tracking-tight font-semibold text-left text-gray-900 capitalize">
                    {language} Question Section CSat
                </p>
                <div className="mt-4">
                    <p className="flex items-center capitalize text-lg font-medium text-gray-900">
                        Write Question
                    </p>
                </div>
            </div>

            <div className="border border-gray-300 rounded-md p-3 mt-3">
                <input
                    className="border border-gray-300 rounded-md w-full p-2"
                    type="text"
                    name={`${prefix}.question`}
                    placeholder={`Enter question (${language})`}
                    value={question || ""}
                    onChange={handleChange}
                />

                <ImageUpload
                    name={`${prefix}.question`}
                    setFieldValue={setFieldValue}
                    currentValue={question}
                />

                {touched?.question?.text && errors?.question && (
                    <div className="text-red-600 text-sm mt-2">{errors.question}</div>
                )}
            </div>

            {(getQuestionType === "statement-csat") && (
                <>
                    {statements && (
                        <div className="border border-gray-400 mt-4 p-2">
                            <p className="flex items-center capitalize text-lg font-medium text-gray-900">
                                Statements
                            </p>
                            <hr className="my-2" />
                            {statements.map((statement, index) => (
                                <div key={index} className="flex items-center space-x-2 mt-2 ">
                                    <div className="border border-gray-300 rounded-md p-3 mt-3 w-full">
                                        <input
                                            className="border pl-4 border-gray-300 hover:border-gray-400 rounded-md w-full py-2 px-3 text-gray-800 leading-tight outline-none"
                                            type="text"
                                            placeholder={`Statement ${index + 1}`}
                                            value={statement}
                                            onChange={(e) =>
                                                handleStatementChange(index, e.target.value)
                                            }
                                        />
                                        <ImageUpload
                                            name={"statement"}
                                            setFieldValue={setFieldValue}
                                            currentValue={statement}
                                            handleStatementChange={handleStatementChange}
                                            index={index}
                                        />
                                    </div>
                                    <div className="flex sm:mt-0 space-x-2">
                                        {index === statements.length - 1 && (
                                            <button
                                                type="button"
                                                onClick={handleAddStatement}
                                                className="h-8 w-8 flex justify-center items-center bg-[#124699] text-white rounded-full hover:bg-[#124699]"
                                                title="Add Statement"
                                            >
                                                <MdAdd />
                                            </button>
                                        )}
                                        {index > 0 || statements.length > 1 ? (
                                            <button
                                                type="button"
                                                onClick={() => handleRemoveStatement(index)}
                                                className="h-8 w-8 flex justify-center items-center bg-red-500 text-white rounded-full hover:bg-red-600"
                                                title="Remove Statement"
                                            >
                                                <MdDelete />
                                            </button>
                                        ) : null}
                                    </div>
                                </div>
                            ))}
                            {touched?.statements && errors?.statements && (
                                <div className="text-red-600 text-sm mt-2">
                                    {Array.isArray(errors.statements)
                                        ? errors.statements.find(
                                            (err, i) => touched.statements[i]
                                        ) || errors.statements[0]
                                        : errors.statements}
                                </div>
                            )}
                        </div>
                    )}
                </>
            )}

            {(getQuestionType === "statement-csat") && (
                <div className="mt-4">
                    <p className="flex items-center capitalize text-lg font-medium text-gray-900">
                        Last Question
                    </p>
                    <div className="border border-gray-300 rounded-md p-3 mt-3">
                        <input
                            className="border pl-2 text-lg border-gray-400 hover:border-gray-400 rounded-md w-full py-2 px-3 text-gray-800 leading-tight outline-none mt-3"
                            id={`${prefix}lastQuestion`}
                            type="text"
                            placeholder={`Enter statement (${language})`}
                            name={`${prefix}.lastQuestion`}
                            onChange={handleChange}
                            value={questionData?.lastQuestion}
                        />
                        <ImageUpload
                            name={`${prefix}.lastQuestion`}
                            setFieldValue={setFieldValue}
                            currentValue={questionData?.lastQuestion || ""}
                        />
                        {touched?.lastQuestion && errors?.lastQuestion && (
                            <div className="text-red-600 text-sm mt-2">
                                {errors.lastQuestion}
                            </div>
                        )}
                    </div>
                </div>
            )}

            <div className="md:p-4 p-2 ">
                <p className="flex items-center capitalize text-xl font-medium text-gray-900">
                    Options
                </p>
                <div className="grid md:grid-cols-4 grid-cols-2 gap-3 flex-wrap mt-3">
                    {Object.keys(optionData.english).map((option) => (
                        <div key={option} className="relative">

                            <label className="flex mb-2 text-start capitalize text-base font-medium text-gray-700">
                                Option - {option}
                                <MdStar className="text-[#124699] h-3 w-3" />
                            </label>
                            <div className="border border-gray-300 rounded-md p-3 mt-3">
                                <input
                                    type="text"
                                    name={`${prefix}.options.${option}`}
                                    value={values[prefix]?.options?.[option] || ""}
                                    onChange={(e) => handleInputChange(e, option)}
                                    onFocus={() => handleInputFocus(option)}
                                    onBlur={() => handleInputBlur(option)}
                                    className="block w-full p-2 border rounded-lg bg-white placeholder-gray-400 text-gray-600 border-gray-300 text-sm outline-none"
                                    placeholder={`Option ${option}`}
                                />
                                <ImageUpload
                                    name={`${prefix}.options.${option}`}
                                    setFieldValue={setFieldValue}
                                    currentValue={values[prefix]?.options?.[option] || ""}
                                />
                            </div>

                            {showSuggestions[option] && (
                                <ul className="absolute w-full bg-white border border-gray-300 rounded-md mt-1 shadow-lg z-50">
                                    {filteredSuggestions[option].map((item, index) => (
                                        <li
                                            key={index}
                                            className="px-2 cursor-pointer hover:bg-gray-200 line-clamp-1 py-0 mt-2"
                                            onClick={() => handleSuggestionClick(option, item)}
                                        >
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    ))}
                </div>
            </div>

            <div className="md:p-4 p-2 mt-2">
                <p className="flex items-center capitalize text-xl font-medium text-gray-900">
                    Answer
                </p>
                <ul className="grid md:grid-cols-4 grid-cols-2 gap-5 md:gap-x-6 w-full text-sm font-medium text-gray-900 mt-4">
                    {Object.keys(options).map((key) => (
                        <li key={key}>
                            <div className="flex items-center ps-3">
                                <input
                                    id={`radio${key}`}
                                    type="radio"
                                    name={`${prefix}.answer`}
                                    value={key}
                                    checked={answer === key}
                                    onChange={(e) => {
                                        handleChange(e);
                                        sharedAnswerHandler(e.target.value);
                                    }}
                                    className="w-4 h-4 text-blue-600 border-gray-300 checked:bg-blue-600 checked:outline-none"
                                />
                                <label
                                    htmlFor={`radio${key}`}
                                    className="w-full ms-2 text-sm font-medium text-gray-900 line-clamp-1"
                                >
                                    Option {key}
                                </label>
                            </div>
                        </li>
                    ))}
                </ul>
                {touched?.answer && errors?.answer && (
                    <div className="text-red-600 text-sm mt-1">{errors.answer}</div>
                )}
            </div>

            <div className="mt-2">
                <p className="flex items-center capitalize text-lg font-medium text-gray-900 mb-2">
                    Solution ({language})
                </p>
                <div className="border border-gray-300 rounded-md p-3 mt-3">

                    <textarea
                        id="message"
                        rows="20"
                        name={`${prefix}.solution`}
                        onChange={handleChange}
                        value={solution}
                        className="border pl-2 text-md border-gray-300 rounded-md w-full min-h-[100px] py-2 px-3 text-gray-800 leading-tight outline-none"
                        placeholder={`Enter solution (${language})...`}
                    />
                    <ImageUpload
                        name={`${prefix}.solution`}
                        setFieldValue={setFieldValue}
                        currentValue={solution || ""}
                    />
                    {touched?.solution && errors?.solution && (
                        <div className="text-red-600 text-sm">{errors.solution}</div>
                    )}
                </div>

            </div>
        </div>
    )
}

export default CSat